import {app} from "@tva/app";
import {downgradeComponent} from "@angular/upgrade/static";
import * as angular from "angular";
import {HeaderComponent} from "./components/header/header.component";

app.directive(
  "appHeader",
  downgradeComponent({
    component: HeaderComponent,
  }) as angular.IDirectiveFactory
);
